blue.ready('heroIE-login', '.heroIE', hero => {
	const inputs = [...hero.querySelectorAll('.heroIE-loginInput')]
	const submit = hero.querySelector('.heroIE-loginBtn--signIn')
	const url = 'https://online.uhcu.org/UHCUOnline_41/uux.aspx'
	let params = {}

	const valid = () => {
		let valid = true
		inputs.forEach(input => {
			if (input.value) {
				input.classList.remove('is-error')
				if (input.getAttribute('type') == 'password') {
					params.password = input.value
				}
				else {
					params.user_id = input.value
				}
			}
			else {
				input.classList.add('is-error')
				valid = false
			}
		})

		return valid;
	}

	const login = (e) => {
		e.preventDefault();
		if (valid()) {
			let form = document.createElement('FORM')
			form.setAttribute('method', 'post');
			form.setAttribute('action', url);

			Object.keys(params).forEach(key => {
				let field = document.createElement('INPUT');
				field.setAttribute('type', 'hidden');
				field.setAttribute('name', key);
				field.setAttribute('value', params[key]);
				form.appendChild(field);
			})
			document.body.appendChild(form);
			form.submit();
		}
	}

  if(submit) {
    submit.addEventListener('click', login);
  }
	inputs.forEach(input => blue.meth.addEvents(input, 'enter.stop.prevent', login))
})

blue.ready('heroIE-forgot', '.heroIE', hero => {
	const inputs = [...hero.querySelectorAll('.heroIE-loginInput')]
	const submit = hero.querySelector('.heroIE-loginLink--forgot')
	const url = 'https://online.uhcu.org/UHCUOnline_41/uux.aspx'
	let params = {}

	const valid = () => {
		let valid = true
		inputs.forEach(input => {
			if (input.getAttribute('type') != 'password') {
				if (input.value) {
					input.classList.remove('is-error')
					params.user_id = input.value
					params.forgot_password = true
				}
				else {
					input.classList.add('is-error')
					valid = false
				}
			}
		})
		return valid;
	}

	const login = (e) => {
		e.preventDefault();
		if (valid()) {
			let form = document.createElement('FORM')
			form.setAttribute('method', 'post');
			form.setAttribute('action', url);

			Object.keys(params).forEach(key => {
				let field = document.createElement('INPUT');
				field.setAttribute('type', 'hidden');
				field.setAttribute('name', key);
				field.setAttribute('value', params[key]);
				form.appendChild(field);
			})
			document.body.appendChild(form);
			form.submit();
		}
	}

  if(submit) {
    submit.addEventListener('click', login);
  }
})